import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from "react";
import { connect } from "unistore/react";
import * as PointSet from "./point-set";
import FloatingRect, { mapStateToProps } from "./FloatingRect";

var Selected = function Selected(props) {
  return /*#__PURE__*/React.createElement(FloatingRect, Object.assign({}, props, {
    variant: "selected"
  }));
};

export default connect(function (state) {
  var cells = state.selected;
  var nextState = mapStateToProps(cells)(state);
  return _objectSpread({}, nextState, {
    hidden: nextState.hidden || PointSet.size(cells) === 1,
    dragging: state.dragging
  });
})(Selected);